import React from 'react';

const FleetManagement = (props) => (
    <svg
        width="22px"
        height="19px"
        viewBox="0 0 22 19"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/Trans b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-387.000000, -1414.000000)" stroke="#000000" stroke-width="1.4">
                <g id="Group" transform="translate(388.000000, 1415.000000)">
                    <path
                        d="M2,9.5 L2,4.7 C2,4.0372583 2.44771525,3.5 3,3.5 L13,3.5 C13.5522847,3.5 14,4.0372583 14,4.7 L14,9.5"
                        id="Path"
                    ></path>
                    <polyline id="Path" stroke-linejoin="round" points="5 3.5 5 0.1 7 0.1 7 3.5"></polyline>
                    <line x1="4.5" y1="6.5" x2="9.5" y2="6.5" id="Line" stroke-linecap="round"></line>
                    <polygon id="Rectangle" stroke-linejoin="round" points="0 9.5 20 9.5 16 16.5 4 16.5"></polygon>
                </g>
            </g>
        </g>
    </svg>
);

export default FleetManagement;
